module.exports = __webpack_public_path__ + "static/walkieImage-23ad0a6959b12ce34091f630476b1427.png";